<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">实训课考勤情况</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择状态">
            <el-option label="待审核" value="apply"></el-option>
            <el-option label="已通过" value="pass"></el-option>
            <el-option label="已拒绝" value="refuse"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_name" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学年学期">
          <el-select v-model="formInline.term" clearable filterable placeholder="请选择学年学期">
            <el-option v-for="(item,index) in $store.state.termms" :key="index" :label="item.term" :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="formInline.course_name" clearable placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" :disabled="exportTitle=='导出中...'" @click="handleExportByUrl(formInline)">{{exportTitle}}</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="course_name" label="课程名称" width="180">
        </custom-table-column>
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="160">
        </custom-table-column>
        <custom-table-column prop="week" label="周次" width="100">
        </custom-table-column>
        <custom-table-column prop="xq" label="星期" width="100">
        </custom-table-column>
        <custom-table-column prop="sector" label="节次" width="100">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级名称" width="180">
        </custom-table-column>
        <custom-table-column prop="item_num" label="项目数" width="100">
        </custom-table-column>
        <custom-table-column prop="people_number" label="人数" width="100">
        </custom-table-column>
        <custom-table-column prop="class_hour" label="上课学时数（小时）" width="140">
        </custom-table-column>
        <custom-table-column prop="teacher" label="指导教师" width="120">
        </custom-table-column>
        <custom-table-column prop="class_content" label="课程内容" min-width="220" show-overflow-tooltip>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click="handleSigns(scope.row)" type="text" size="small">签到情况</el-button>
            <el-button @click="handleExportByUrl({class_plan_id:scope.row.id})"  type="text" size="small">导出记录</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="签到情况" :visible.sync="detailDialogVisible" width="806px">
      <el-dialog :close-on-click-modal="false" title="签到详情" :visible.sync="scoreDialogVisible" width="306px" append-to-body>
      <div style="padding:0px 32px 32px;">
      <p style="margin-bottom: 32px;">
      {{studentInfo.name}}-{{studentInfo.course_name}}
      </p>
        <el-timeline >
          <el-timeline-item v-for="(activity, index) in activities" :key="index" :timestamp="activity.sign_date">
            签到时间：
          </el-timeline-item>
        </el-timeline>
      </div>
      </el-dialog>
      <!-- <div>
        <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
          <el-form-item label="学生姓名">
            <el-input v-model="formInline1.student" clearable placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery1">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleScoreStudent">新增评价</el-button>
          </el-form-item>
        </el-form>
      </div> -->
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed prop="name" width="140" label="学生">
          </custom-table-column>
          <custom-table-column fixed prop="number" width="140" label="学号">
          </custom-table-column>
          <custom-table-column prop="class_name" min-width="180" label="班级名称">
          </custom-table-column>
          <custom-table-column prop="sign_count" width="80" label="签到次数">
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="handleSignDetail(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </custom-table-column>
        </custom-table>
        <!-- <div class="pageLine">
          <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible  = false">取 消</el-button>
        <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan,mixinImport],
  data() {
    return {
      classRooms: [],
      formInline1: {
        class_plan_id: '',
        student_id: '',
      },
      tableData1: [],
      total1: 0,
      organLabel: '',
      selectName: '',
      formInline: {
        training_name: '',
        status: '',
        structure_1: '',
        structure_2: '',
        course_name: '',
        term: '',
      },
      rules: {
        student: [{ required: true, message: '请选择学生', trigger: 'change' }],
        content: [{ required: true, message: '请输入总评', trigger: 'blur' }],
        items: [{ required: true, trigger: 'blur' }],
      },
      ruleForm: {
        class_plan_id: '',
        type: 2,
        content: '',
        student: '',
        items: '',
      },
      items: [],
      itemsTep: [],
      scoreDialogVisible: false,
      detailDialogVisible: false,
      levell: [1, 2],
      loading: false,
      type: 'add',
      tableName: '实训日志',
      users: [],
      course_name: '',
      students: [],
      activities:[],
      exportTitle:"导出记录",
      studentInfo:{}
    };
  },
  created() {
    this.exportUrl = `${this.baseUrlt}api/teacher/course/student_signed_record_list_export`
  },
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTermms');
    
    // this.getQulityItems();

    // this.getUsers()
  },
  watch: {
    itemsTep: {
      handler: function (val) {
        this.ruleForm.items = JSON.stringify(val);
      },
      deep: true,
    },
  },
  methods: {
    handleSigns(row) {
      this.detailDialogVisible = true;
      this.formInline1.class_plan_id = row.id;
      // this.ruleFormTep.class_plan_id = row.id
      // this.formInline1.course_name = row.course_name;
      this.handleQuery1();
    },
    handleSignDetail(row) {
      this.scoreDialogVisible = true;
      this.studentInfo = row
      this.formInline1.student_id = row.student_id;
      this.getSignDetail();
    },
    async getSignDetail() {
      let params = this.$until.deleteNullPrototype(this.formInline1);
      let res = await this.$api.instance.interfaceServer('api/teacher/course/student_signed_record', 'get', params);
      if (res.code == 0 && res.data) {
        this.activities = res.data
      }
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;
    },
    getOrganList() {
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.structure_2 = strArr[1];
        this.ruleForm.class_name = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.structure_2 = '';
        this.ruleForm.class_name = '';
      }
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteCourse(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteStudentGrade(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList1();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.createClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleScoreStudent() {
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      this.scoreDialogVisible = true;
      this.getClassStudents();
      this.itemsTep = this.$until.deepCopy(this.items);
    },
    async getClassStudents() {
      let res = await this.$api.query.getClassStudents({ id: this.ruleForm.class_plan_id });
      if (res.code == 0) {
        this.students = res.data;
      }
    },
    async getQulityItems() {
      let res = await this.$api.query.getQulityItems({ type: 2 });
      if (res.code == 0) {
        this.items = res.data.map((val) => {
          return {
            id: val.id,
            item: val.item,
            content: val.content,
            max_score: val.score,
            score: val.score,
          };
        });
      }
    },
    async submitScore() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.submitScore(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    clearState() {
      this.resetForm('ruleForm');
      this.ruleForm = this.ruleFormTep;
      this.scoreDialogVisible = false;
      this.getList1();
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleQuery1() {
      this.$nextTick(() => {
        // this.$refs.pageChild1.page = 1;
        this.getList1();
      });
    },
    async getList1() {
      // let params = this.$until.deleteNullPrototype(this.formInline1);
      let res = await this.$api.instance.interfaceServer('api/teacher/course/student_signed_record_list', 'get', { class_plan_id: this.formInline1.class_plan_id });
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data;
      }
    },
    handleQuery() {
      this.beforeQuery1();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getClassPlanList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
/deep/.custom-table .cell {
  text-overflow: unset;
}
</style>
